/**
 * we have a very simplistic dropdown model. In our model, a dropdown must fit a very specific structure where it contains at a minimum:
 * - a variable trigger element
 * - a fixed menu list
 *
 * When the trigger is hit, the class "open" is applied to the menu list container. Then, when the body receives a subsequent
 * click, the container loses it's open class.
 *
 * An example of valid dropdown markup:
 * <div class="dropdown">
 *     <div class="menu-item">
 *         <span class="something">This is text</span>
 *
 *         <span class="trigger"></span>
 *
 *         <ul class="dropdown-menu">
 *             <li>1</li>
 *             <li>2</li>
 *          </ul>
 *      </div>
 * </div>
 *
 * @param $el - the element to create dropdown functionality for. This should be the element containing both the menu and
 * the trigger
 */
const Dropdown = Backbone.Model.extend({
    defaults: {
        isOpen: false
    }
});

const DropdownView = Backbone.View.extend({
    events: {
        'click .arrow-down': 'toggleDropdown'
    },

    initialize() {
        this.model.on('change:isOpen', this.render, this);
    },

    $menu() {
        return this.$el.find('.dropdown-menu');
    },

    toggleDropdown() {
        this.model.set({isOpen: !this.model.get('isOpen')});
    },

    render() {
        this.model.get('isOpen') ? this.$menu().addClass('open') : this.$menu().removeClass('open');
    }
});

const DropdownOverlay = Backbone.View.extend({
    template: _.template('<div class="dropdown-overlay<% if (!visible) { %> invisible<% } %>"></div>'),
    events: {
        'click': 'hideDropdown'
    },

    initialize() {
        this.model.on('change:isOpen', this.render, this);
    },

    hideDropdown() {
        this.model.set({isOpen: false});
    },

    render() {
        this.$el.html(this.template({
            visible: this.model.get('isOpen')
        }));
    }
});


let createDrop = ($el, $overlay) => {
    let dropdownModel = new Dropdown();

    new DropdownView({ model: dropdownModel, el: $el });
    new DropdownOverlay({ model: dropdownModel, el: $overlay });
};


module.exports = createDrop;



// WEBPACK FOOTER //
// ./assets/js/app/lib/dropdown.js